import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './AdPopup.css';

const apiUrl = process.env.REACT_APP_API_URL || 'https://www.nualily.es';
const DEFAULT_REPEAT = 10; // minutos

const AdPopup = ({ isAuthenticated }) => {
  const [adData, setAdData] = useState(null);
  const navigate = useNavigate();

  /* ---------------------------- refs para cleanup --------------------------- */
  const startTimeoutRef = useRef(null);
  const intervalRef     = useRef(null);

  /* ---------------------------- fetch anuncio ------------------------------ */
  const fetchAd = async () => {
    try {
      const { data: ads } = await axios.get(`${apiUrl}/api/ad`);

      if (Array.isArray(ads) && ads.length > 0) {
        const currentAd  = ads[0];
        const now        = new Date(new Date().toISOString()); // UTC
        const startDate  = new Date(currentAd.startDate);
        const endDate    = new Date(currentAd.endDate);
        const intervalMin = currentAd.repeatInterval ?? DEFAULT_REPEAT;

        if (now >= startDate && now <= endDate) {
          const lastAdViewTime = localStorage.getItem('lastAdViewTime');
          const timeDiff = lastAdViewTime
            ? (now - new Date(lastAdViewTime)) / (1000 * 60)
            : intervalMin + 1;

          if (timeDiff >= intervalMin && !adData) {
            setAdData(currentAd);
            localStorage.setItem('lastAdViewTime', now.toISOString());
          }
        }
      }
    } catch {
      /* silencio */
    }
  };

  /* ------------------------ iniciar con retardo 10 s ------------------------ */
  useEffect(() => {
    if (!isAuthenticated) return;

    // primer intento a los 10 s
    startTimeoutRef.current = setTimeout(() => {
      fetchAd();
      // luego cada minuto
      intervalRef.current = setInterval(fetchAd, 60 * 1000);
    }, 10 * 1000);

    return () => {
      clearTimeout(startTimeoutRef.current);
      clearInterval(intervalRef.current);
    };
  }, [isAuthenticated]);

  /* --------------------------- cerrar popup -------------------------------- */
  const handleCloseAd = (e) => {
    e.stopPropagation();           // evita que el clic burbujee a la media
    if (!adData) return;

    const minutes = adData.repeatInterval ?? DEFAULT_REPEAT;
    const nextShowTime = new Date(Date.now() + minutes * 60 * 1000);
    localStorage.setItem('lastAdViewTime', nextShowTime.toISOString());

    setAdData(null);
  };

  /* ---------------------- click en imagen / vídeo -------------------------- */
  const handleMediaClick = () => {
    handleCloseAd(new MouseEvent('click')); // re-usa el cierre

    if (adData?.externalUrl) {
      window.open(adData.externalUrl, '_blank', 'noopener,noreferrer');
    } else if (adData?.productId) {
      navigate(`/product/${adData.productId}`);
    }
  };

  /* ----------------------------- render ------------------------------------ */
  if (!adData || !isAuthenticated) return null;

  const mediaUrl    = adData.media[0];
  const isVideo     = /\.(mp4|webm|ogg)$/i.test(mediaUrl.split('?')[0]);
  const isClickable = Boolean(adData.externalUrl || adData.productId);

  return (
    <div className="ad-popup">
      <div className="ad-popup-content">
        {isVideo ? (
          <video
            src={mediaUrl}
            controls
            autoPlay
            loop
            className="ad-popup-media"
            onClick={isClickable ? handleMediaClick : undefined}
            style={{ cursor: isClickable ? 'pointer' : 'default' }}
          />
        ) : (
          <img
            src={mediaUrl}
            alt="Anuncio"
            className="ad-popup-media"
            onClick={isClickable ? handleMediaClick : undefined}
            style={{ cursor: isClickable ? 'pointer' : 'default' }}
          />
        )}

        <span className="ad-popup-close" onClick={handleCloseAd}>✕</span>
      </div>
    </div>
  );
};

export default AdPopup;
